import _ from 'lodash';
import React, {Component} from 'react';
import {Dropdown, Menu, Header, Table, Grid} from 'semantic-ui-react';
import ChartsData from "../../data/ChartsData";
import LoadingRow from "../extras/LoadingRow";
import * as moment from "moment";
import FilterBar from "../reports/FilterBar";
import NoData from "../extras/NoData";
const c = require("../../constants");

const options = [
    { key: 'ingredient', text: 'Ingredientes', value: 'ingredient' },
    { key: 'product', text: 'Productos', value: 'product' },
    { key: 'recipes', text: 'Recetas', value: 'recipes' },
]

class TableStockBranch extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            column: null,
            direction: null,
            selected_option: 'product',
            loading: true,
            time: null,
            branch_office: '',
            date: moment.now()
        }
        this.loadData = this.loadData.bind(this)
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    async loadData(branch_office, time, date) {
        this.setState({loading: true, time, date});
        ChartsData.getStockBranchOffice(branch_office).then(data =>{
            data.sort((a,b) => {return (a.total < b.total) ? 1 : ((b.total < a.total) ? -1 : 0);} );
            this.setState({data, branch_office});
        }).finally(()=>{
            this.setState({loading: false});
        });
    };

    handleSort = clickedColumn => () => {
        const { column, data, direction } = this.state;
        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                direction: 'ascending',
            });

            return
        }
        this.setState({
            data: data.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    };

    render() {
        return (
            <React.Fragment>
                <Header as='h2' floated='right'>
                    <Menu compact floating>
                        <Dropdown
                            simple item
                            name='selected_option'
                            options={options}
                            value={this.state.selected_option}
                            onChange={this.handleChange}
                        />
                    </Menu>
                </Header>
                <Grid.Row>
                    <FilterBar title='Inventario por Sucursal' callbackGetFilter={this.loadData} download={true} show_date={false} url_download={`charts/stock-branch-office/${this.state.branch_office}/excel-report`}/>
                </Grid.Row>
                <Table sortable celled fixed striped selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell sorted={this.state.column === 'name' ? this.state.direction : null}
                                              onClick={this.handleSort('name')}>
                                Nombre
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'type' ? this.state.direction : null}
                                              onClick={this.handleSort('type')}>
                                Categoría
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={this.state.column === 'total' ? this.state.direction : null}
                                              onClick={this.handleSort('total')}>
                                Unidades Disponibles
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {!this.state.loading ? this.state.data.length > 0 ? _.map(this.state.data.filter(data => data.type === this.state.selected_option), ({id, name, type, total, unit}, index) => (
                            <Table.Row key={index} error={total < 5} warning={total >= 5 && total <= 10}>
                                <Table.Cell>{name}</Table.Cell>
                                <Table.Cell>{type === 'product' ? 'Producto':type === 'ingredient' ? 'Ingrediente':'Receta'}</Table.Cell>
                                <Table.Cell>{Math.round((total + Number.EPSILON) * 100) / 100} {unit && type !== 'recipes' ? c.UNITS.find((u) => u.key===unit).abbr:''} {type === 'recipes'? 'porciones':''}</Table.Cell>
                            </Table.Row>
                        )):<NoData colSpan={3}/>:<LoadingRow colSpan={3}/>}
                    </Table.Body>
                </Table>
            </React.Fragment>
        );
    }
}

export default TableStockBranch;



// WEBPACK FOOTER //
// ./src/components/charts/TableStockBranch.js